// @flow

import React, {Fragment} from 'react';

import {ClickToEditButton} from 'app/components/general/ClickToEditButton';
import {StyledTitleH1} from 'app/general/structures/SPPage';
import {gt} from 'app/utils/i18n';

import type {TeamSerializedType} from 'sweet-types';

interface Props {
  team: TeamSerializedType;
  onClick: () => void;
  showNotMemberMessage: boolean;
}

export function DisplayTeamNameAndDescription({
  team: {name, description, can_edit, teammates_can_assign_task},
  onClick,
  showNotMemberMessage,
}: Props): JSX.Element {
  return (
    <Fragment>
      <StyledTitleH1>
        {name}
        {can_edit === true ? (
          <ClickToEditButton
            onClick={onClick}
            tooltip={gt('Click to edit Team')}
          />
        ) : null}
      </StyledTitleH1>

      <p className="description">{description}</p>
      {showNotMemberMessage === true && (
        <div className="alert alert-info">
          {gt(
            'You are not a member of this team. Its documents and folders are limited to those you have permission for.'
          )}
        </div>
      )}

      <p>
        <small>
          {teammates_can_assign_task
            ? gt('Teammates and Managers can assign tasks')
            : gt('Only Managers can assign tasks')}
        </small>
      </p>
    </Fragment>
  );
}
